<template>
  <el-dialog
    v-el-drag-dialog
    :visible.sync="dialogVisible"
    :close-on-click-modal="false"
    :title="skill.pkid ? '编辑' : '新建'"
    width="600px"
    @close="$reset('form')"
  >
    <el-form ref="form" :model="skill" :rules="ruleValidate" class="form" label-width="80px">
      <el-form-item v-if="skill.pkid" label="技能编号">
        <el-input v-model="skill.skillNo" disabled />
      </el-form-item>
      <el-form-item label="技能名称" prop="skillName">
        <el-input v-model="skill.skillName" placeholder="请输入技能名称" clearable />
      </el-form-item>
    </el-form>
    <span slot="footer">
      <el-button @click="dialogVisible = false">取消</el-button>
      <el-button :loading="submitLoading" type="primary" @click="submitHandle">确定</el-button>
    </span>
  </el-dialog>
</template>

<script>
export default {
  data() {
    return {
      dialogVisible: false,
      submitLoading: false,
      skill: {
        skillName: "",
      },
      ruleValidate: {
        skillName: { required: true, message: "请输入技能名称", trigger: "blur" },
      },
    };
  },
  methods: {
    open(row) {
      this.dialogVisible = true;
      if (row) {
        this.skill = Object.assign(this.skill, row);
      }
    },

    // 提交
    submitHandle() {
      this.$refs.form.validate((valid) => {
        if (valid) {
          this.submitLoading = true;
          this.$http
            .save("basic", "skills", this.skill)
            .then((resp) => {
              this.submitLoading = false;
              if (resp.success) {
                if (this.skill.pkid) {
                  this.$emit("save-success");
                  this.$message.success("编辑成功");
                } else {
                  this.$emit("save-success");
                  this.$message.success("添加成功");
                }
                this.dialogVisible = false;
              }
            })
            .catch(() => {
              this.submitLoading = false;
            });
        }
      });
    },
  },
};
</script>
